import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@core/base.component';

interface LawyerMismatchNotificationDialogData {
	leapLawyerName: string;
	closerLawyerName: string;
}

interface VM {
	leapLawyerName: string;
	closerLawyerName: string;
}

const DefaultVMValues: VM = {
	leapLawyerName: '',
	closerLawyerName: '',
};

@Component({
	selector: 'app-lawyer-mismatch-notification',
	templateUrl: './lawyer-mismatch-notification.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LawyerMismatchNotificationComponent
	extends BaseComponent<VM>
	implements OnInit
{
	constructor(
		public dialogRef: MatDialogRef<LawyerMismatchNotificationComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LawyerMismatchNotificationDialogData,
	) {
		super(structuredClone(DefaultVMValues));
	}

	ngOnInit(): void {
		this.VM = {
			leapLawyerName: this.data.leapLawyerName,
			closerLawyerName: this.data.closerLawyerName,
		};
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
